import config from "config/config";
import { getToken } from "js/formatting/getToken";
export async function sendSmsMessage(messageBody, toPhoneNumber) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      messageBody: messageBody,
      toPhoneNumber: toPhoneNumber,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/Notification/sendsms",
    options
  );
  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
